import api from "@/api";

export default {
    // GET /api/tasks/{taskId}/users
    getAssigned(taskId) {
        return api.get(`/api/tasks/${taskId}/users`);
    },
    // POST /api/tasks/{taskId}/users
    assign(taskId, userId) {
        return api.post(`/api/tasks/${taskId}/users`, { userId });
    },
    // DELETE /api/tasks/{taskId}/users/{userId}
    unassign(taskId, userId) {
        return api.delete(`/api/tasks/${taskId}/users/${userId}`);
    }
};